import { Controller } from "@hotwired/stimulus"

// Handles dragging tasks to the calendar
export default class extends Controller {
  static values = {
    taskId: Number,
    title: String,
    duration: { type: Number, default: 30 },
    recurring: { type: Boolean, default: false }
  }

  dragstart(event) {
    // Set task data for calendar drop
    event.dataTransfer.setData("application/x-task-id", this.taskIdValue)
    event.dataTransfer.setData("text/plain", this.titleValue)
    event.dataTransfer.setData("application/x-task-duration", this.durationValue)
    event.dataTransfer.setData("application/x-task-recurring", this.recurringValue)
    event.dataTransfer.effectAllowed = "copyMove"

    // Add visual feedback
    this.element.classList.add("task-dragging")
  }

  dragend(event) {
    this.element.classList.remove("task-dragging")
  }
}
